module.exports = {"addTag":"+ Tilføj tag","add":"Tilføj","close":"Luk","tagPlaceholder":"Angiv et tag ..."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/localization/da-DK/strings.json
// module id = 1198
// module chunks = 0